import useSWR from 'swr';
import { get } from '@/utils/client';

// Api endpoints
import { USER_TEAM_MEMBERS } from '@/lib/routes/apiEndpoints';
import useUser from '@/hooks/swr/useUser';

//types
import type { TeamMemberType } from '@/types/teamMemberType';
import type { AxiosError } from 'axios';
import type { KeyedMutator, SWRConfiguration } from 'swr';

export type MutateTeamMembersType = KeyedMutator<TeamMemberType[]>;

const useTeamMembers = (options?: SWRConfiguration<TeamMemberType[], AxiosError<Error>>) => {
    const { user } = useUser({
        revalidateOnMount: false,
        revalidateOnFocus: false,
        revalidateOnReconnect: false
    });

    const { data, mutate, error, isLoading } = useSWR<TeamMemberType[], AxiosError<Error>>(
        USER_TEAM_MEMBERS,
        (url) => get(url).then((res) => res?.data?.data?.members),
        {
            shouldRetryOnError: false,
            revalidateOnFocus: false,
            ...options
        }
    );

    const otherMembersOnly = data?.filter((team_member) => team_member.id !== user?.id);

    const AdminId = data?.[0]?.admin_id;

    const membersExceptAdmin = data?.filter((member) => member.id !== AdminId);

    return {
        teamMembers: data || [],
        adminAccount: AdminId ? data.find((member) => member.id === AdminId) : null,
        membersExceptAdmin,
        otherMembersOnly,
        mutateTeamMembers: mutate,
        teamMembersError: error,
        isLoading
    };
};

export default useTeamMembers;
